import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    actionContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 300
    },
    keySelectorContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    languageSelector: {
        flexDirection: "row",
        alignItems: "center"
    },
    contentWrapper: {
        borderWidth: 1,
        width: "100%"
    },
    formContainer: {
        width: "100%"
    },
    editorSection: {
        width: "100%"
    },
    container: {
        width: "100%"
    }
});
export default stylesheet;
